module.exports = __webpack_public_path__ + "static/media/old-forklift.58a08659.svg";